export enum GameStateMachineStates {
  Accelerate = 'accelerate',
  WaitRequest = 'waitRequest',
  WaitAccelerationComplete = 'waitAccelerationComplete',
  Bonus = 'bonus',
  EndBonus = 'endBonus',
  BonusRecovery = 'bonusRecovery',
  FreeSpin = 'freeSpin',
  FreeSpinRecovery = 'freeSpinRecovery',
  FreeSpinsCompletion = 'freeSpinsCompletion',
  Idle = 'idle',
  InitGame = 'initGame',
  MakeRequest = 'makeRequest',
  RegularSpin = 'regularSpin',
  AutoSpin = 'AutoSpin',
  BeginRespin = 'BeginRespin',
  Respin = 'Respin',
  Stop = 'stop',
  Animation = 'animation',
  EndAnimation = 'endAnimation',
  ShortWinLines = 'ShortWinLines',
  Stopping = 'stopping',
  ImmediatelyStop = 'immediatelyStop',
  BeginFreeSpins = 'beginFreeSpins',
  EndOfFreeSpins = 'endOfFreeSpins',
  BeginScatter = 'beginScatter',
  Scatter = 'scatter',
  EndOfFreeSpinsPopup = 'endFreeSpinsPopup',
  ReBuyFreeSpinsPopup = 'reBuyFreeSpinsPopup',
  BeginFreeSpinsPopup = 'beginFreeSpinsPopup',
  BeginBonus = 'beginBonus',
  EndScatter = 'endScatter',
  BeginCollapse = 'beginCollapseState',
  Collapse = 'collapseState',
  EndCollapse = 'endCollapseState',
  EndShortWinLines = 'endShortWinLines',
  SpinRequest = 'spinRequest',
  BuyFreeSpinsRequest = 'buyFreeSpinsRequest',
  // BGaming legacy states (stubs)
  StartPage = 'startPage',
}
